import { localStorageUtil, sessionStorageUtil } from "../utils/storage";

export const createVerificationOTP = async (email, amcCode, type) => {
  if (!amcCode) amcCode = sessionStorageUtil.getAmcCode();

  const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;
  const guestToken = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/investor/generate-${type}-otp`, {
      method: "POST",
      headers: {
        Authorization: guestToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: guestEmail,
        amc_code: amcCode,
        user_email: email,
      }),
    });

    const data = await response.json();

    if (!response.ok || data?.status !== 200) {
      throw new Error("Failed to generate OTP");
    }

    return {
      error: false,
      message: data?.message,
    };
  } catch (error) {
    // console.log(error);
    return {
      error: true,
      message: error?.message || "Failed to generate OTP",
    };
  }
};

export const handleOtpVerification = async (email, amcCode, otp, type) => {
  if (!amcCode) amcCode = sessionStorageUtil.getAmcCode();

  const guestEmail = process.env.REACT_APP_API_GUEST_EMAIL;
  const guestToken = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/investor/verify-${type}-otp`, {
      method: "POST",
      headers: {
        Authorization: guestToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: guestEmail,
        amc_code: amcCode,
        user_email: email,
        otp,
      }),
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error("Invalid OTP");
    }

    return {
      error: false,
      message: data?.message,
    };
  } catch (error) {
    // console.log(error);
    return {
      error: true,
      message: error?.message || "Invalid OTP",
    };
  }
};

export const getInvestorVerificationDetails = async (email, amcCode) => {
  // const token = sessionStorageUtil.getAccessToken() || process.env.REACT_APP_API_GUEST_TOKEN;
  const token = sessionStorageUtil.getAccessToken();
  // const code = amcCode || sessionStorageUtil.getAmcCode();
  // const token = localStorageUtil.getRefreshToken();
  // const token = process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/investor/email?email=${encodeURIComponent(email)}&amc_code=${encodeURIComponent(amcCode)}`, {
      // const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/investor/email`, {
      method: "GET",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data.message || "Get Investor Details - Failed");
    }

    return {
      data: data?.data,
      message: "Get Investor Details - Success",
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error.message || "Get Investor Details - Failed",
      error: true,
    };
  }
};
